import React from 'react';

export const MEMBER_STATUS_DETAILS = {
  member: { label: 'Accepted', summary: 'accepted' },
  invited: { label: 'Awaiting response', summary: 'awaiting response' },
  declined: { label: 'Declined', summary: 'declined' },
  left: { label: 'Left', summary: 'left' },
  active: { label: 'Active', summary: 'active' },
};

export const doctorInitials = (doctor = {}) => {
  const structured = [doctor.firstName, doctor.lastName]
    .map((part) => String(part || '').trim())
    .filter(Boolean);
  const nameParts = String(doctor.name || '')
    .split(/\s+/)
    .filter((part) => part && !/^(dr|doctor|docteur)\.?$/i.test(part));
  const parts = structured.length > 0 ? structured : nameParts;

  if (parts.length === 0) return '?';
  return [parts[0], parts.length > 1 ? parts.at(-1) : null]
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .join('');
};

export const doctorDisplayName = (doctor = {}) => doctor.name
  || [doctor.firstName, doctor.lastName].filter(Boolean).join(' ')
  || 'Doctor';

export function MemberAvatars({ members = [], limit = 5, showStatusSummary = false, showNamesTooltip = false }) {
  const visible = members.slice(0, limit);
  const hidden = Math.max(0, members.length - limit);
  const memberNames = members.map(({ doctor }) => doctorDisplayName(doctor));
  const statusCounts = members.reduce((counts, member) => {
    const status = member.status || 'active';
    counts[status] = (counts[status] || 0) + 1;
    return counts;
  }, {});

  const avatars = (
    <div
      className="collab-avatars"
      aria-label={showNamesTooltip ? `Collaboration doctors: ${memberNames.join(', ')}` : `${members.length} collaboration members`}
      title={showNamesTooltip ? memberNames.map((name) => `• ${name}`).join('\n') : undefined}
    >
      {visible.map((member) => {
        const status = member.status || 'active';
        const statusDetail = MEMBER_STATUS_DETAILS[status] || MEMBER_STATUS_DETAILS.active;
        return (
          <span
            className={`collab-avatar collab-avatar--${status}`}
            key={member.id || member.doctor?.id}
            title={showNamesTooltip ? undefined : `${doctorDisplayName(member.doctor)} · ${statusDetail.label}`}
          >
            {doctorInitials(member.doctor)}
          </span>
        );
      })}
      {hidden > 0 && <span className="collab-avatar collab-avatar--more">+{hidden}</span>}
    </div>
  );

  if (!showStatusSummary) return avatars;

  return (
    <div className="collab-participants">
      {avatars}
      {members.length > 0 ? (
        <div className="collab-member-states" aria-label="Participant invitation status">
          {Object.entries(statusCounts).map(([status, count]) => (
            <span className={`collab-member-state collab-member-state--${status}`} key={status}>
              {count} {(MEMBER_STATUS_DETAILS[status] || MEMBER_STATUS_DETAILS.active).summary}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default MemberAvatars;
